import React from 'react'
import { StaticGrid } from 'components/common'
import { contactWorksColumnDefinitions } from './config/ContactWorksColumns'

/**
 * Static nested table component to display works for a contact (for ≤ 50 works)
 * @param {Object} props
 * @param {Object} props.contact - The contact object containing works data
 */
const ContactWorksStaticTable = ({ contact }) => {
    const { worksCount, works, contactId } = contact

    // Add unique ID to each row to avoid duplicate key issues
    // WorkCode is not unique as a contact can have multiple contributions to the same work
    const worksList = (works || []).map((work, index) => ({
        ...work,
        uniqueId: `${contactId}_${work.workCode || ''}_${work.contributionType || ''}_${index}`
    }))

    return (
        <div className="p-3">
            <h5>Works ({worksCount})</h5>
            <StaticGrid
                id={`contact_works_static_grid_${contactId}`}
                dataKey="uniqueId"
                data={worksList}
                emptyMessage="No works found"
                columnDefinitions={contactWorksColumnDefinitions}
                scrollHeight="400px"
                rowPerPage={10}
            />
        </div>
    )
}

export default ContactWorksStaticTable
